import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fixed } from 'layouts';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControlLabel,
  Tooltip,
  Radio,
  Checkbox,
  ListItemText,
  FormLabel,
  FormGroup,
  Card,
  Typography,
  TextField,
  OutlinedInput,
  Chip,
  Modal,
  InputAdornment,
  CircularProgress,
  Icon,
  Divider,
  DialogContentText,
  RadioGroup,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  Drawer,
} from '@mui/material';
import moment from 'moment';
import {
  Add,
  AddCircle,
  Assignment,
  ChevronRight,
  Close,
  CloudDownload,
  ContentCopy,
  CopyAll,
  Delete,
  DeleteOutline,
  Description,
  Edit,
  EditOutlined,
  ExpandMore,
  Group,
  Link,
  Lock,
  Mic,
  MoreVert,
  Notes,
  Redo,
  Replay,
  Send,
  StopCircle,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import getFeaturePreviews from 'redux/actions/Common/getFeaturePreviews';
import deleteFeaturePreview from 'redux/actions/Common/deleteFeaturePreview';
import createFeaturePreview from 'redux/actions/Common/createFeaturePreview';
import updateFeaturePreview from 'redux/actions/Common/updateFeaturePreview';
import parse from 'html-react-parser';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const defaultLabels = [
  'clarity',
  'pace',
  'fluency',
  'confidence',
  'enthusiasm',
  'delivery',
  'content',
];

const FeaturePreviews = () => {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname, state } = useLocation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isXs = useMediaQuery(theme.breakpoints.only('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.only('sm'), {
    defaultMatches: true,
  });
  const chatsScrollview = useRef(null);
  const drawerContentRef = useRef(null);

  const [
    showConfirmDeleteFeaturePreview,
    setShowConfirmDeleteFeaturePreview,
  ] = useState(null);

  const [deletingFeaturePreview, setDeletingFeaturePreview] = useState(false);

  const [fetchingFeaturePreviews, setFetchingFeaturePreviews] = useState(false);
  const [
    showAddFeaturePreviewDialog,
    setShowAddFeaturePreviewDialog,
  ] = useState(false);
  const [addingFeaturePreview, setAddingFeaturePreview] = useState(false);
  const [featurePreviewTitle, setFeaturePreviewTitle] = useState('');
  const [featurePreviewContent, setFeaturePreviewContent] = useState('');
  const [featurePreviews, setFeaturePreviews] = useState([]);

  const [showFeaturePreview, setShowFeaturePreview] = useState(null);
  const [previewHeight, setPreviewHeight] = useState('700px');

  useEffect(() => {
    if (drawerContentRef?.current) {
      setPreviewHeight(drawerContentRef.current?.clientHeight - 30);
    }
  }, [drawerContentRef?.current]);

  useEffect(() => {
    setFetchingFeaturePreviews(true);
    dispatch(
      getFeaturePreviews(
        (res) => {
          setFeaturePreviews(res);
          setFetchingFeaturePreviews(false);
        },
        () => {
          setFetchingFeaturePreviews(false);
        },
      ),
    );
  }, []);

  return (
    <Fixed>
      <Box
        width={{ xs: '100vw', sm: '100vw', md: 'calc(100vw - 266px)' }}
        height={{
          xs: 'calc(100vh - 60px)',
          sm: 'calc(100vh - 70px)',
          md: 'calc(100vh - 80px)',
        }}
        sx={{
          overflow: 'hidden',
        }}
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'column' }}
        position={'relative'}
        gap={1}
      >
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          padding={2}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              border: '1px solid #d3d3d3',
              borderRadius: 2,
              padding: 2,
              width: 1,
              height: 1,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography color={'text.secondary'}>Feature Previews</Typography>
              <Tooltip arrow placement="top" title="Add more">
                <AddCircle
                  sx={{
                    color: '#a3a3a3',
                    fontSize: 20,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setShowAddFeaturePreviewDialog(true);
                  }}
                />
              </Tooltip>
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                minHeight: 'calc(100vh - 200px)',
                maxHeight: 'calc(100vh - 200px)',
                overflowY: 'scroll',
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: 2,
                },
              }}
              // onScroll={handleListScroll}
            >
              <Table
                sx={{ minWidth: 750 }}
                stickyHeader
                aria-label="simple table"
              >
                <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                  <TableRow>
                    <TableCell>
                      <Typography
                        variant={'caption'}
                        fontWeight={700}
                        sx={{ textTransform: 'uppercase' }}
                      >
                        ID
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant={'caption'}
                        fontWeight={700}
                        sx={{ textTransform: 'uppercase' }}
                      >
                        TITLE
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant={'caption'}
                        fontWeight={700}
                        sx={{ textTransform: 'uppercase' }}
                        align="center"
                      >
                        DATE
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant={'caption'}
                        fontWeight={700}
                        sx={{ textTransform: 'uppercase' }}
                        align="center"
                      >
                        ACTIONS
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {featurePreviews
                    ?.sort((a, b) => b?.createdOn - a?.createdOn)
                    .map((featurePreview, i) => (
                      <TableRow
                        key={i}
                        // sx={{
                        //   '&:last-child td, &:last-child th': {
                        //     border: 0,
                        //   },
                        // }}
                      >
                        <TableCell component="th" scope="row">
                          <Typography variant={'subtitle2'} fontWeight={700}>
                            {featurePreview?.id}
                          </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Typography variant={'subtitle2'} fontWeight={700}>
                            {featurePreview?.title}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant={'caption'}
                            // fontWeight={700}
                            // sx={{
                            //   color: theme.palette.success.main,
                            // }}
                          >
                            {moment(featurePreview?.createdOn).format(
                              'DD MMMM YYYY',
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box display={'flex'} alignItems={'center'} gap={1}>
                            <Tooltip title={'Copy Link'} placement="top" arrow>
                              <IconButton
                                onClick={() => {
                                  try {
                                    navigator.clipboard.writeText(
                                      featurePreview?.customFields?.link,
                                    );
                                  } catch (error) {
                                    console.error(
                                      'Failed to copy text:',
                                      error,
                                    );
                                  }
                                }}
                              >
                                <ContentCopy color={'default'} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={'Preview Content'}
                              placement="top"
                              arrow
                            >
                              <IconButton
                                onClick={() => {
                                  setShowFeaturePreview(featurePreview);
                                }}
                              >
                                <Assignment color="default" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={'Edit Feature Preview'}
                              placement="top"
                              arrow
                            >
                              <IconButton
                                onClick={() => {
                                  setFeaturePreviewTitle(featurePreview?.title);
                                  setFeaturePreviewContent(
                                    featurePreview?.featurePreviewPageContent,
                                  );
                                  setShowAddFeaturePreviewDialog(
                                    featurePreview,
                                  );
                                }}
                              >
                                <Edit
                                  color={
                                    featurePreview.transcript
                                      ? 'primary'
                                      : 'default'
                                  }
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={'Delete'} placement="top" arrow>
                              <IconButton
                                onClick={() => {
                                  setShowConfirmDeleteFeaturePreview(
                                    featurePreview?.id,
                                  );
                                }}
                              >
                                <Delete color={'default'} />
                              </IconButton>
                              {/* )} */}
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
                {/* <TableFooter>
                                <TableRow>
                                  <TableCell
                                    variant="footer"
                                    colSpan={6}
                                    sx={{
                                      padding: 0,
                                    }}
                                  >
                                    
                                  </TableCell>
                                </TableRow>
                              </TableFooter> */}
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
      <Modal
        open={Boolean(showAddFeaturePreviewDialog)}
        onClose={(e, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown')
            setShowAddFeaturePreviewDialog(false);
          else return;
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            // maxHeight: '30vh',
            maxWidth: '50vw',
            minWidth: '40vw',
            outline: 'none',
            borderRadius: 1,
            // padding: 3,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              padding: 2,
            }}
          >
            <TextField
              label="Title"
              variant="outlined"
              value={featurePreviewTitle}
              onChange={(e) => {
                setFeaturePreviewTitle(e.target.value);
              }}
            />
            <TextField
              label="HTML Content"
              variant="outlined"
              multiline
              rows={10}
              value={featurePreviewContent}
              onChange={(e) => {
                setFeaturePreviewContent(e.target.value);
              }}
            />
          </Box>
          <Box
            width={1}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            p={'8px 16px'}
            borderTop={'1px solid #d3d3d3'}
          >
            <Button
              size="small"
              variant="outlined"
              onClick={(e) => {
                setShowAddFeaturePreviewDialog(false);
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={
                addingFeaturePreview ? <CircularProgress size={16} /> : null
              }
              disabled={
                !featurePreviewTitle ||
                !featurePreviewContent ||
                addingFeaturePreview
              }
              onClick={(e) => {
                if (
                  showAddFeaturePreviewDialog &&
                  typeof showAddFeaturePreviewDialog === 'object'
                ) {
                  setAddingFeaturePreview(true);
                  dispatch(
                    updateFeaturePreview(
                      showAddFeaturePreviewDialog?.id,
                      {
                        title: featurePreviewTitle,
                        content: featurePreviewContent,
                      },
                      () => {
                        setShowAddFeaturePreviewDialog(false);
                        setAddingFeaturePreview(false);
                        dispatch(
                          getFeaturePreviews((data) => {
                            setFeaturePreviews(data);
                          }),
                        );
                      },
                    ),
                  );
                } else {
                  setAddingFeaturePreview(true);
                  dispatch(
                    createFeaturePreview(
                      {
                        title: featurePreviewTitle,
                        content: featurePreviewContent,
                      },
                      () => {
                        setShowAddFeaturePreviewDialog(false);
                        setAddingFeaturePreview(false);
                        dispatch(
                          getFeaturePreviews((data) => {
                            setFeaturePreviews(data);
                          }),
                        );
                      },
                    ),
                  );
                }
              }}
              color="primary"
            >
              {addingFeaturePreview ? 'Adding...' : 'Add'}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog
        open={Boolean(showConfirmDeleteFeaturePreview)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          minWidth: 400,
          // '& .MuiPaper-root-MuiDialog-paper': {
          //   maxWidth: '70vw',
          // },
        }}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              minWidth: 400,
            }}
          >
            <Typography variant="body1">
              Are you sure you want to delete this feature preview?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            width={1}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-end'}
          >
            <Button
              // data-trackid={'cta_permission_denied_dialog_close'}
              onClick={(e) => {
                setShowConfirmDeleteFeaturePreview(null);
              }}
              color="primary"
              // autoFocus
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={deletingFeaturePreview}
              startIcon={
                deletingFeaturePreview ? <CircularProgress size={20} /> : null
              }
              onClick={(e) => {
                setDeletingFeaturePreview(true);
                dispatch(
                  deleteFeaturePreview(showConfirmDeleteFeaturePreview, () => {
                    setShowConfirmDeleteFeaturePreview(null);
                    setDeletingFeaturePreview(false);
                    dispatch(
                      getFeaturePreviews(
                        (data) => {
                          console.log(data);
                          setFeaturePreviews(data || []);
                        },
                        () => {
                          console.log('error');
                          setFeaturePreviews([]);
                        },
                      ),
                    );
                  }),
                );
              }}
              color="primary"
              // autoFocus
            >
              Yes
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Drawer
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={Boolean(showFeaturePreview)}
        anchor="right"
        onClose={(e, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            // boxShadow: theme.shadows[5],
            outline: 'none',
            maxHeight: '100vh',
            maxWidth: '50vw',
            minWidth: '50vw',
            overflowY: 'auto',
            borderRadius: 1,
            position: 'relative',
          }}
        >
          <Box
            p={1}
            sx={{
              borderBottom: '1px solid #d3d3d3',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={() => {
                setShowFeaturePreview(null);
              }}
            >
              <ChevronRight sx={{}} />
            </IconButton>
            <Typography color={'text.secondary'}>
              {showFeaturePreview?.title}(Feature Preview)
            </Typography>
          </Box>
          <Box
            // ref={drawerContentRef}
            sx={{
              minHeight: 'calc(100vh - 80px)',
              maxHeight: 'calc(100vh - 80px)',
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              },
              padding: 2,
            }}
            ref={drawerContentRef}
          >
            <iframe
              src={`data:text/html;charset=utf-8,${encodeURIComponent(
                showFeaturePreview?.featurePreviewPageContent,
              )}`}
              style={{
                width: '100%',
                height: previewHeight,
              }}
              allowFullScreen
              allowTransparency
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            />
          </Box>
        </Box>
      </Drawer>
    </Fixed>
  );
};

export default FeaturePreviews;
